import Script from 'next/script';

// TypeScript declaration for gtag function
declare global {
  interface Window {
    _hsq: unknown[][];
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}
const GTM_KEY = process.env.NEXT_PUBLIC_GTM_KEY;
export const GTag = () => {
  if (!GTM_KEY) {
    throw new Error('Missing NEXT_PUBLIC_GTM_KEY environment variable');
  }
  return <>
      {/*
        Initialize dataLayer, gtag function, and consent defaults.
         Stays `beforeInteractive`: Google Consent Mode requires the consent
        defaults to be registered before Cookiebot (sync script in _document)
        pushes its consent update, otherwise storage is briefly ungated. It is
        also the stub `useGTag` relies on being present when effects first run.
        No network cost — inline only.
       */}
      <Script
    // biome-ignore lint/security/noDangerouslySetInnerHtml: Needed for gtag initialization
    dangerouslySetInnerHTML={{
      __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
          }
          gtag("consent", "default", {
            ad_personalization: "denied",
            ad_storage: "denied",
            ad_user_data: "denied",
            analytics_storage: "denied",
            functionality_storage: "granted",
            personalization_storage: "granted",
            security_storage: "granted",
            wait_for_update: 500,
          });
          gtag("set", "ads_data_redaction", true);
          gtag("set", "url_passthrough", true);`
    }} data-cookieconsent="ignore" id="gtag-init" strategy="beforeInteractive" data-sentry-element="Script" data-sentry-source-file="GTag.tsx" />

      {/* Google Tag Manager */}
      <Script
    // biome-ignore lint/security/noDangerouslySetInnerHtml: Needed for GTM initialization
    dangerouslySetInnerHTML={{
      __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'/metrics/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_KEY}');`
    }} id="gtm" strategy="afterInteractive" data-sentry-element="Script" data-sentry-source-file="GTag.tsx" />
    </>;
};